/**
 * 时间工具函数
 */

/**
 * 格式化时间戳为日期时间字符串
 * @param {number} timestamp - 时间戳(秒或毫秒)
 * @param {string} format - 格式模板,默认 'YYYY-MM-DD HH:mm:ss'
 * @returns {string} 格式化后的日期时间字符串
 */
export function formatTimestamp(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!timestamp) return '-';
  
  // 如果是秒级时间戳(10位),转换为毫秒
  const ts = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
  
  const date = new Date(ts);
  
  // 检查是否为有效日期
  if (isNaN(date.getTime())) return '-';
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
}

/**
 * 格式化时间戳为日期字符串(不含时间)
 * @param {number} timestamp - 时间戳(秒或毫秒)
 * @returns {string} 格式化后的日期字符串
 */
export function formatDate(timestamp) {
  return formatTimestamp(timestamp, 'YYYY-MM-DD');
}

/**
 * 格式化时间戳为时间字符串(不含日期)
 * @param {number} timestamp - 时间戳(秒或毫秒)
 * @returns {string} 格式化后的时间字符串
 */
export function formatTime(timestamp) {
  return formatTimestamp(timestamp, 'HH:mm:ss');
}

/**
 * 获取相对时间描述(例如: 刚刚、5分钟前、2小时前、3天前等)
 * @param {number} timestamp - 时间戳(秒或毫秒)
 * @returns {string} 相对时间描述
 */
export function getRelativeTime(timestamp) {
  if (!timestamp) return '-';
  
  // 如果是秒级时间戳(10位),转换为毫秒
  const ts = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
  
  const now = Date.now();
  const diff = now - ts;
  
  // 小于1分钟
  if (diff < 60000) return '刚刚';
  
  // 小于1小时
  if (diff < 3600000) {
    const minutes = Math.floor(diff / 60000);
    return `${minutes}分钟前`;
  }
  
  // 小于1天
  if (diff < 86400000) {
    const hours = Math.floor(diff / 3600000);
    return `${hours}小时前`;
  }
  
  // 小于7天
  if (diff < 604800000) {
    const days = Math.floor(diff / 86400000);
    return `${days}天前`;
  }
  
  // 超过7天,显示具体日期
  return formatDate(ts);
}
